import type { TvPlatform } from "$modules/expo-tv-connect-remote";

const TV_TAG = /^\[TV\]\s*/i;
const SAMSUNG = /^Samsung\b/i;
const LG_TAG = /^\[LG\]\s*/i;
const LG_WEBOS_TV_PREFIX = /^LG\s+webos\s*tv\b/i;
const WEBOS_TV_PREFIX = /^webos\s*tv\b/i;

const normalizeTvDeviceName = (name: string, platform: TvPlatform): string => {
  const trimmed = name.trim();

  if (platform === "tizen") {
    const model = trimmed.replace(TV_TAG, "").replace(SAMSUNG, "").trim();

    return model;
  }

  if (platform === "webos") {
    const model = trimmed
      .replace(LG_TAG, "")
      .replace(LG_WEBOS_TV_PREFIX, "")
      .replace(WEBOS_TV_PREFIX, "")
      .replace(/\s+/g, " ")
      .trim();

    return model;
  }

  return trimmed.trim();
};

export default normalizeTvDeviceName;
